exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv.bs {margin-left: 0px;\n}\ndiv.bs2 {margin-top: auto;\n}\ndiv.bstest {\n\twidth: 50%;\n\tmargin-left: 290px;\n}\n\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e31ba32","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Management/User/DetailForm.vue
// module id = BaIR
// module chunks = 1